module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC7SURBVHgBlVGxDYMwELTfLQUj4ArRxRMk2YQNWIUVMklgAtMhKjMCFSJI2PknJlVE7JPetk531uuOMw+tdZokSeWcu9F4usOp8zx/HDpOR9/3GQA88Zmx3xittfeiKMbdMAyDORF/TfM8K4G/l5zzkv1HKoR44SZQsUCg4Qp4X0INFAawSADu30ToO9i2rY0w1NwYk67rqllArFigBCnlRKUQcSb2mk/TB6gTH/OeHKbS4LTLstRKqYm4NyhfTHoHmfVPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/dot.png
// module id = f6T9
// module chunks = 1